import { render, staticRenderFns } from "./DownLoad.vue?vue&type=template&id=09916b2a&scoped=true"
import script from "./DownLoad.vue?vue&type=script&lang=js"
export * from "./DownLoad.vue?vue&type=script&lang=js"
import style0 from "./DownLoad.vue?vue&type=style&index=0&id=09916b2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09916b2a",
  null
  
)

export default component.exports